import { memo } from 'react'
import { Logo } from '@campgladiator/cgui-core.atoms.logo'
import { Heading } from '@campgladiator/cgui-core.atoms.typography'

const LoginHeader = memo(() => (
  <header className="login-header">
    <Logo type="icon" iconType="white" width="40px" />
    <Heading type="h4" className="login-header__content uppercase">
      Fit Challenge
    </Heading>
  </header>
))

export default LoginHeader
